import FolderIcon from '@mui/icons-material/Folder';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import ConfirmationButtonDelete from 'components/ui/feedback/ConfirmationButtonDelete';
import { useTranslation } from 'react-i18next';
import { IFolder } from '../types';

interface FolderCardProps {
  folder: IFolder;
  canDelete: boolean;
  onSelect: (folder: IFolder) => void;
  onDelete: (folder: IFolder) => void;
}

export const FolderCard = ({ folder, canDelete, onSelect, onDelete }: FolderCardProps) => {
  const { t } = useTranslation();

  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <Card
        variant="outlined"
        sx={{
          height: '100%',
          borderRadius: 2,
          borderColor: 'divider',
          transition: 'background-color 0.2s, transform 0.2s',
          '&:hover': { bgcolor: 'action.hover', transform: 'translateY(-2px)' }
        }}>
        <CardContent
          sx={{
            p: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1.5,
            '&:last-child': { pb: 2 }
          }}>
          <Box
            onClick={() => onSelect(folder)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              cursor: 'pointer',
              flexGrow: 1,
              minWidth: 0
            }}>
            <FolderIcon sx={{ color: '#29456c', fontSize: 36, flexShrink: 0 }} />
            <Box sx={{ minWidth: 0 }}>
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 700,
                  color: 'text.primary',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}>
                {t(folder.name.split('/').pop() || folder.name)}
              </Typography>
              {folder.description && (
                <Typography
                  variant="caption"
                  sx={{
                    fontWeight: 500,
                    color: 'text.secondary',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    display: 'block'
                  }}>
                  {folder.description}
                </Typography>
              )}
            </Box>
          </Box>
          {canDelete && (
            <Box sx={{ flexShrink: 0 }}>
              <ConfirmationButtonDelete
                id={folder.id}
                iconButton={true}
                handleDelete={() => onDelete(folder)}
              />
            </Box>
          )}
        </CardContent>
      </Card>
    </Grid>
  );
};
